/**
 * Skills Intelligence Page - Standalone dashboard
 * Navigate here via /capacity-skills/intelligence
 */

import { SkillsIntelligenceDashboard } from '@/components/SkillsIntelligenceDashboard';
import { useNavigation } from '@/contexts/NavigationContext';
import { cn } from '@/lib/utils';
import { BarChart3 } from 'lucide-react';

export function SkillsIntelligencePage() {
  const { sectionColor } = useNavigation();

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className={cn("text-3xl font-bold", sectionColor)}>Skills Intelligence</h1>
          <p className="text-neutral-400 mt-2">
            Comprehensive analytics for team capabilities, gaps, and succession risks
          </p>
        </div>
        <BarChart3 className={cn("w-8 h-8", sectionColor)} />
      </div>

      {/* Dashboard Component */}
      <SkillsIntelligenceDashboard />
    </div>
  );
}
